import * as React from 'react'
import Svg, {
  SvgProps,
  Defs,
  RadialGradient,
  Stop,
  LinearGradient,
  G,
  Path,
  Text,
  TSpan,
  Circle,
  Rect,
} from 'react-native-svg'
import { Image } from 'expo-image'
import ColoredText from '../../CustomText/ColoredText'
import { Platform, TouchableOpacity, View } from 'react-native'
/* SVGR has dropped some elements not supported by react-native-svg: title */
const AR_6 = ({
  props,
  report,
  year,
  onClose,
}: {
  props?: SvgProps
  report: Record<string, any>
  year: string
  onClose: () => Promise<void>
}) => {
  return (
    <>
      <Svg width={393} height={852} {...props}>
        <Defs>
          <RadialGradient
            id="c"
            cx="50%"
            cy="100%"
            r="222.877%"
            fx="50%"
            fy="100%"
            gradientTransform="matrix(0 -1 .2143 0 .286 1.5)"
          >
            <Stop offset="0%" stopColor="#FFF" />
            <Stop offset="100%" stopColor="#FBEFC5" />
          </RadialGradient>
          <RadialGradient
            id="d"
            cx="50%"
            cy="100%"
            r="222.877%"
            fx="50%"
            fy="100%"
            gradientTransform="matrix(0 -1 .2143 0 .286 1.5)"
          >
            <Stop offset="0%" stopColor="#FFF" />
            <Stop offset="100%" stopColor="#FBEFC5" />
          </RadialGradient>
          <LinearGradient id="a" x1="0%" x2="102.004%" y1="100%" y2="0%">
            <Stop offset="0%" stopColor="#FA6A00" />
            <Stop offset="100%" stopColor="#FFCD12" />
          </LinearGradient>
          <LinearGradient id="b" x1="50%" x2="50%" y1="100%" y2="-38.034%">
            <Stop offset="0%" stopColor="#FF5F01" />
            <Stop offset="100%" stopColor="#FFC700" />
          </LinearGradient>
          {/* {Platform.OS !== 'web' && (
            <>
              <Image
                style={{ top: 217, left: 17, width: 85, height: 85, borderRadius: 100, backgroundColor: 'white' }}
                id="a"
                source={report.data.runner[0].cThumbnail.cURLKlein}
                contentFit="cover"
              />
              <ColoredText style={{ top: 130, left: 125, width: 250, color: `#000`, fontSize: 16, maxHeight: 60 }}>
                {report.data.runner[0].cName}
              </ColoredText>
              <ColoredText
                style={{
                  top: 140,
                  left: 125,
                  width: 250,
                  color: `#000`,
                  fontSize: 18,
                  maxHeight: 40,
                  fontFamily: `Comfortaa-Bold`,
                }}
              >
                {`${report.data.runner[0].nAmount} mal verkauft`}
              </ColoredText>
              <Image
                style={{ top: 160, left: 32, width: 85, height: 85, borderRadius: 100, backgroundColor: 'white' }}
                id="a"
                source={report.data.runner[1].cThumbnail.cURLKlein}
                contentFit="cover"
              />
              <ColoredText style={{ top: 80, left: 140, width: 250, color: `#000`, fontSize: 14, maxHeight: 60 }}>
                {report.data.runner[1].cName}
              </ColoredText>
              <ColoredText
                style={{
                  top: 90,
                  left: 140,
                  width: 250,
                  color: `#000`,
                  fontSize: 16,
                  maxHeight: 40,
                  fontFamily: `Comfortaa-Bold`,
                }}
              >
                {`${report.data.runner[1].nAmount} mal verkauft`}
              </ColoredText>
              <Image
                style={{ top: 110, left: 32, width: 85, height: 85, borderRadius: 100, backgroundColor: 'white' }}
                id="a"
                source={report.data.runner[2].cThumbnail.cURLKlein}
                contentFit="cover"
              />
              <ColoredText style={{ top: 30, left: 140, width: 250, color: `#000`, fontSize: 14, maxHeight: 60 }}>
                {report.data.runner[2].cName}
              </ColoredText>
              <ColoredText
                style={{
                  top: 40,
                  left: 140,
                  width: 250,
                  color: `#000`,
                  fontSize: 16,
                  maxHeight: 40,
                  fontFamily: `Comfortaa-Bold`,
                }}
              >
                {`${report.data.runner[2].nAmount} mal verkauft`}
              </ColoredText>
              <Image
                style={{ top: 58, left: 32, width: 85, height: 85, borderRadius: 100, backgroundColor: 'white' }}
                id="a"
                source={report.data.runner[3].cThumbnail.cURLKlein}
                contentFit="cover"
              />
              <ColoredText style={{ top: -23, left: 140, width: 250, color: `#000`, fontSize: 14, maxHeight: 60 }}>
                {report.data.runner[3].cName}
              </ColoredText>
              <ColoredText
                style={{
                  top: -10,
                  left: 140,
                  width: 250,
                  color: `#000`,
                  fontSize: 16,
                  maxHeight: 40,
                  fontFamily: `Comfortaa-Bold`,
                }}
              >
                {`${report.data.runner[3].nAmount} mal verkauft`}
              </ColoredText>
              <Image
                style={{ top: 8, left: 32, width: 85, height: 85, borderRadius: 100, backgroundColor: 'white' }}
                id="a"
                source={report.data.runner[4].cThumbnail.cURLKlein}
                contentFit="cover"
              />
              <ColoredText style={{ top: -73, left: 140, width: 250, color: `#000`, fontSize: 14, maxHeight: 60 }}>
                {report.data.runner[4].cName}
              </ColoredText>
              <ColoredText
                style={{
                  top: -63,
                  left: 140,
                  width: 250,
                  color: `#000`,
                  fontSize: 16,
                  maxHeight: 40,
                  fontFamily: `Comfortaa-Bold`,
                }}
              >
                {`${report.data.runner[4].nAmount} mal verkauft`}
              </ColoredText>
            </>
          )} */}
        </Defs>
        <G fill="none" fillRule="evenodd">
          <Path fill="#FFF" d="M0 0h393v852H0z" />
          <Path fill="url(#a)" d="M185.667 0h1080v1080h-1080z" transform="matrix(-1 0 0 1 657 -64)" />
          <Path
            fill="url(#b)"
            d="M325.595 361.5h940.072c0 259.049-6.667 155.45-6.667 306.5s-17.333 11 0 261.5l-933.405-21C145.774 908.5 0 786.05 0 635s145.774-273.5 325.595-273.5Z"
            opacity={0.202}
            transform="matrix(-1 0 0 1 657 -64)"
          />
          <Path
            fill="#FFF"
            fillRule="nonzero"
            d="M201.5 729.25h10.687a.51.51 0 0 0 .399-.187.624.624 0 0 0 .164-.422 10.913 10.913 0 0 0-1.594-5.203 11.31 11.31 0 0 0-3.844-3.844A10.913 10.913 0 0 0 202.11 718a.624.624 0 0 0-.422.164.51.51 0 0 0-.187.399v10.687Zm12.422 2.25h-10.688l7.547 7.547c.125.125.266.18.422.164a.684.684 0 0 0 .422-.211 10.983 10.983 0 0 0 2.039-3.234c.484-1.188.758-2.407.82-3.657a.624.624 0 0 0-.164-.421.51.51 0 0 0-.398-.188Zm-7.125 6.797-7.547-7.547v-10.687a.51.51 0 0 0-.188-.399.624.624 0 0 0-.421-.164 11.3 11.3 0 0 0-5.344 1.711 11.195 11.195 0 0 0-3.867 4.055c-.953 1.687-1.43 3.53-1.43 5.53 0 2 .508 3.86 1.523 5.58a11.465 11.465 0 0 0 4.102 4.1c1.719 1.016 3.594 1.524 5.625 1.524a11.175 11.175 0 0 0 7.547-2.906.595.595 0 0 0 .164-.375.506.506 0 0 0-.164-.422ZM36.5 173.25h10.687a.51.51 0 0 0 .399-.187.624.624 0 0 0 .164-.422 10.913 10.913 0 0 0-1.594-5.203 11.31 11.31 0 0 0-3.844-3.844A10.913 10.913 0 0 0 37.11 162a.624.624 0 0 0-.422.164.51.51 0 0 0-.187.399v10.687Zm12.422 2.25H38.234l7.547 7.547c.125.125.266.18.422.164a.684.684 0 0 0 .422-.211 10.983 10.983 0 0 0 2.039-3.234c.484-1.188.758-2.407.82-3.657a.624.624 0 0 0-.164-.421.51.51 0 0 0-.398-.188Zm-7.125 6.797-7.547-7.547v-10.687a.51.51 0 0 0-.188-.399.624.624 0 0 0-.421-.164 11.3 11.3 0 0 0-5.344 1.711 11.195 11.195 0 0 0-3.867 4.055c-.953 1.687-1.43 3.53-1.43 5.53 0 2 .508 3.86 1.523 5.58a11.465 11.465 0 0 0 4.102 4.1c1.719 1.016 3.594 1.524 5.625 1.524a11.175 11.175 0 0 0 7.547-2.906.595.595 0 0 0 .164-.375.506.506 0 0 0-.164-.422ZM349.571 720.571a2.572 2.572 0 0 1 2.572-2.571h1.714a2.572 2.572 0 0 1 2.572 2.571v18.858a2.572 2.572 0 0 1-2.572 2.571h-1.714a2.572 2.572 0 0 1-2.572-2.571V720.57ZM341 730.857a2.572 2.572 0 0 1 2.571-2.571h1.715a2.572 2.572 0 0 1 2.571 2.571v8.572a2.572 2.572 0 0 1-2.571 2.571h-1.715a2.572 2.572 0 0 1-2.571-2.571v-8.572Zm21.429-9.428A2.572 2.572 0 0 1 365 724v15.429a2.572 2.572 0 0 1-2.571 2.571h-1.715a2.572 2.572 0 0 1-2.571-2.571V724a2.572 2.572 0 0 1 2.571-2.571h1.715ZM62 725.174c0 .648-.552 1.174-1.232 1.174H40.232c-.68 0-1.232-.48-1.232-1.174 0-.648.552-1.174 1.186-1.174h2.89c.346-2.63 2.387-4.751 5.056-5.322.289-.988 1.192-1.678 2.368-1.678h3.193c1.192 0 2.285.768 2.51 1.882.257 1.5-.898 2.77-2.417 2.77H50.5c-.68 0-1.296-.263-1.74-.64-1.642.33-2.894 1.521-3.22 2.988h15.228c.683 0 1.232.567 1.232 1.174Zm-20.536 2.74h18.072l-1.48 12.693c-.093.793-.805 1.393-1.642 1.393H44.586c-.838 0-1.549-.6-1.641-1.393l-1.48-12.694Zm4.903 6.637 1.694 1.572-.397 2.226c-.078.403.372.703.744.513l2.092-1.051 2.092 1.051c.379.19.822-.11.744-.513l-.397-2.226 1.694-1.572a.486.486 0 0 0-.289-.837l-2.343-.33-1.046-2.024a.522.522 0 0 0-.918 0l-1.046 2.024-2.343.33a.485.485 0 0 0-.28.837ZM364 96.174c0 .648-.552 1.174-1.232 1.174h-20.536c-.68 0-1.232-.48-1.232-1.174 0-.648.552-1.174 1.186-1.174h2.89c.346-2.63 2.387-4.751 5.056-5.322.289-.988 1.192-1.678 2.368-1.678h3.193c1.192 0 2.285.768 2.51 1.882.257 1.5-.898 2.77-2.417 2.77H352.5c-.68 0-1.296-.263-1.74-.64-1.642.33-2.894 1.521-3.22 2.988h15.228c.683 0 1.232.567 1.232 1.174Zm-20.536 2.74h18.072l-1.48 12.693c-.093.793-.805 1.393-1.642 1.393h-11.828c-.838 0-1.549-.6-1.641-1.393l-1.48-12.694Zm4.903 6.637 1.694 1.572-.397 2.226c-.078.403.372.703.744.513l2.092-1.051 2.092 1.051c.379.19.822-.11.744-.513l-.397-2.226 1.694-1.572a.486.486 0 0 0-.289-.837l-2.343-.33-1.046-2.024a.522.522 0 0 0-.918 0l-1.046 2.024-2.343.33a.485.485 0 0 0-.28.837Z"
            opacity={0.292}
          />
          <Path
            fill="url(#c)"
            d="M69.102 208.5h358.455c33.898 0 61.379 23.084 61.379 51.559 0 28.475-27.48 51.558-61.38 51.558H69.103c-33.899 0-61.38-23.083-61.38-51.558S35.204 208.5 69.103 208.5Z"
            opacity={0.202}
          />
          <Path
            fill="url(#d)"
            d="M81.786 315h331.632c31.362 0 56.786 21.356 56.786 47.7 0 26.345-25.424 47.7-56.786 47.7H81.786C50.424 410.4 25 389.046 25 362.7c0-26.344 25.424-47.7 56.786-47.7ZM81.786 414h331.632c31.362 0 56.786 21.356 56.786 47.7 0 26.345-25.424 47.7-56.786 47.7H81.786C50.424 509.4 25 488.046 25 461.7c0-26.344 25.424-47.7 56.786-47.7ZM81.786 513h331.632c31.362 0 56.786 21.356 56.786 47.7 0 26.345-25.424 47.7-56.786 47.7H81.786C50.424 608.4 25 587.046 25 560.7c0-26.344 25.424-47.7 56.786-47.7ZM81.786 612h331.632c31.362 0 56.786 21.356 56.786 47.7 0 26.345-25.424 47.7-56.786 47.7H81.786C50.424 707.4 25 686.046 25 659.7c0-26.344 25.424-47.7 56.786-47.7Z"
            opacity={0.202}
          />
          <Text
            fill="#000"
            fontFamily={'Comfortaa_500Medium'}
            fontSize={24}
            fillRule={Platform.OS !== 'android' ? 'nonzero' : 'evenodd'}
          >
            <TSpan x={69.272} y={189}>
              {`Top 5 Produkte ${year}`}
            </TSpan>
          </Text>
          <Text
            fill="#FFF"
            fontFamily={'Comfortaa_700Bold'}
            fontSize={40}
            fillRule={Platform.OS !== 'android' ? 'nonzero' : 'evenodd'}
          >
            <TSpan x={10} y={129}>
              {'Produkte'}
            </TSpan>
          </Text>
          <G transform="translate(351 50)" onPress={onClose}>
            <Circle cx={14.5} cy={14.5} r={14.5} fill="#1E2239" />
            <Path
              fill="#FFF"
              fillRule="nonzero"
              d="M21.711 21.228a1.25 1.25 0 1 1-1.92 1.6l-5.29-6.38-5.29 6.347a1.247 1.247 0 0 1-1.76.16 1.25 1.25 0 0 1-.16-1.76l5.582-6.7L7.29 7.83a1.25 1.25 0 1 1 1.92-1.6l5.29 6.346 5.29-6.348a1.249 1.249 0 1 1 1.92 1.6l-5.583 6.7 5.584 6.7Z"
            />
          </G>
          <G fill="#D8D8D8" transform="translate(10 58.596)">
            <Rect width={36.056} height={4.807} rx={2.404} />
            <Rect width={36.056} height={4.807} x={42.065} rx={2.404} />
            <Rect width={36.056} height={4.807} x={84.13} rx={2.404} />
            <Rect width={36.056} height={4.807} x={126.195} rx={2.404} />
            <Rect width={36.056} height={4.807} x={167.659} rx={2.404} />
            <Rect width={36.056} height={4.807} x={209.711} rx={2.404} />
            <Rect width={36.056} height={4.807} x={250.827} opacity={0.376} rx={2.404} />
            <Rect width={36.056} height={4.807} x={291.944} opacity={0.376} rx={2.404} />
          </G>
          <Path
            fill="#FFF"
            fillRule="nonzero"
            d="M365.25 175h-3.75v4.714l-1.5-1.046-1.5 1.046V175h-3.75c-.413 0-.75.354-.75.786v9.428c0 .432.337.786.75.786h10.5c.413 0 .75-.354.75-.786v-9.428c0-.432-.337-.786-.75-.786Zm-17.5-2h10.5c.413 0 .75-.354.75-.786v-9.428c0-.432-.337-.786-.75-.786h-3.75v4.714l-1.5-1.046-1.5 1.046V162h-3.75c-.413 0-.75.354-.75.786v9.428c0 .432.337.786.75.786Zm2.5 2h-3.75v4.714l-1.5-1.046-1.5 1.046V175h-3.75c-.413 0-.75.354-.75.786v9.428c0 .432.337.786.75.786h10.5c.413 0 .75-.354.75-.786v-9.428c0-.432-.337-.786-.75-.786Z"
            opacity={0.297}
          />
        </G>
      </Svg>
      {
        <>
          <TouchableOpacity
            onPress={onClose}
            style={{ position: 'absolute', top: 50, marginLeft: 330, width: 50, height: 50 }}
          />
          <View
            style={{
              position: 'absolute',
              top: 217,
              flex: 1,
              marginLeft: 5,
              flexDirection: 'column',
              // backgroundColor: 'green',
            }}
          >
            <View
              style={{
                flex: 1,
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                alignContent: 'flex-start',
                width: 390,
                marginLeft: 40,
              }}
            >
              <Image
                style={{ width: 85, height: 85, borderRadius: 100, backgroundColor: 'white' }}
                id="a"
                source={report.data.runner[0].cThumbnail.cURLKlein}
                contentFit="cover"
              />
              <View style={{ width: 250, marginLeft: 20 }}>
                <ColoredText style={{ width: 250, color: `#000`, fontSize: 16, maxHeight: 60 }}>
                  {report.data.runner[0].cName}
                </ColoredText>
                <ColoredText
                  style={{
                    width: 250,
                    color: `#000`,
                    fontSize: 18,
                    maxHeight: 40,
                    fontFamily: `Comfortaa-Bold`,
                  }}
                >
                  {`${report.data.runner[0].nAmount} mal verkauft`}
                </ColoredText>
              </View>
            </View>
            <View
              style={{
                flex: 1,
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                alignContent: 'flex-start',
                marginLeft: 60,
                marginTop: 18,
                width: 390,
              }}
            >
              <Image
                style={{ width: 85, height: 85, borderRadius: 100, backgroundColor: 'white' }}
                id="a"
                source={report.data.runner[1].cThumbnail.cURLKlein}
                contentFit="cover"
              />
              <View style={{ width: 250, marginLeft: 20 }}>
                <ColoredText style={{ width: 250, color: `#000`, fontSize: 14, maxHeight: 60 }}>
                  {report.data.runner[1].cName}
                </ColoredText>
                <ColoredText
                  style={{
                    width: 250,
                    color: `#000`,
                    fontSize: 16,
                    maxHeight: 40,
                    fontFamily: `Comfortaa-Bold`,
                  }}
                >
                  {`${report.data.runner[1].nAmount} mal verkauft`}
                </ColoredText>
              </View>
            </View>
            <View
              style={{
                flex: 1,
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                alignContent: 'flex-start',
                marginLeft: 60,
                marginTop: 15,
                width: 390,
              }}
            >
              <Image
                style={{ width: 85, height: 85, borderRadius: 100, backgroundColor: 'white' }}
                id="a"
                source={report.data.runner[2].cThumbnail.cURLKlein}
                contentFit="cover"
              />
              <View style={{ width: 250, marginLeft: 20 }}>
                <ColoredText style={{ width: 250, color: `#000`, fontSize: 14, maxHeight: 60 }}>
                  {report.data.runner[2].cName}
                </ColoredText>
                <ColoredText
                  style={{
                    width: 250,
                    color: `#000`,
                    fontSize: 16,
                    maxHeight: 40,
                    fontFamily: `Comfortaa-Bold`,
                  }}
                >
                  {`${report.data.runner[2].nAmount} mal verkauft`}
                </ColoredText>
              </View>
            </View>
            <View
              style={{
                flex: 1,
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                alignContent: 'flex-start',
                marginLeft: 60,
                marginTop: 15,
                width: 390,
              }}
            >
              <Image
                style={{ width: 85, height: 85, borderRadius: 100, backgroundColor: 'white' }}
                id="a"
                source={report.data.runner[3].cThumbnail.cURLKlein}
                contentFit="cover"
              />
              <View style={{ width: 250, marginLeft: 20 }}>
                <ColoredText style={{ width: 250, color: `#000`, fontSize: 14, maxHeight: 60 }}>
                  {report.data.runner[3].cName}
                </ColoredText>
                <ColoredText
                  style={{
                    width: 250,
                    color: `#000`,
                    fontSize: 16,
                    maxHeight: 40,
                    fontFamily: `Comfortaa-Bold`,
                  }}
                >
                  {`${report.data.runner[3].nAmount} mal verkauft`}
                </ColoredText>
              </View>
            </View>
            <View
              style={{
                flex: 1,
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                alignContent: 'flex-start',
                marginLeft: 60,
                marginTop: 15,
                width: 390,
              }}
            >
              <Image
                style={{ width: 85, height: 85, borderRadius: 100, backgroundColor: 'white' }}
                id="a"
                source={report.data.runner[4].cThumbnail.cURLKlein}
                contentFit="cover"
              />
              <View style={{ width: 250, marginLeft: 20 }}>
                <ColoredText style={{ width: 250, color: `#000`, fontSize: 14, maxHeight: 60 }}>
                  {report.data.runner[4].cName}
                </ColoredText>
                <ColoredText
                  style={{
                    width: 250,
                    color: `#000`,
                    fontSize: 16,
                    maxHeight: 40,
                    fontFamily: `Comfortaa-Bold`,
                  }}
                >
                  {`${report.data.runner[4].nAmount} mal verkauft`}
                </ColoredText>
              </View>
            </View>
          </View>
        </>
      }
    </>
  )
}
export default AR_6
